/**
 * Scene photos for Word Wheel play / hub.
 * Files live in `public/bg_images/word-wheel`.
 */

const PUBLIC = process.env.PUBLIC_URL || "";

export const BG_IMAGE_CATALOG = {
    beach: `${PUBLIC}/bg_images/word-wheel/beach.png`,
    classroom: `${PUBLIC}/bg_images/word-wheel/classroom.png`,
    deep_sea: `${PUBLIC}/bg_images/word-wheel/deep_sea.png`,
    farm_gate: `${PUBLIC}/bg_images/word-wheel/farm_gate.png`,
    flowers: `${PUBLIC}/bg_images/word-wheel/flowers.png`,
    island: `${PUBLIC}/bg_images/word-wheel/island.png`,
    mountain: `${PUBLIC}/bg_images/word-wheel/mountain.png`,
    road: `${PUBLIC}/bg_images/word-wheel/road.png`,
    tropical_island: `${PUBLIC}/bg_images/word-wheel/tropical_island.png`,
    urban: `${PUBLIC}/bg_images/word-wheel/urban.png`,
    village: `${PUBLIC}/bg_images/word-wheel/village.png`,
};

export const BG_IMAGE_IDS = Object.keys(BG_IMAGE_CATALOG).sort();

/** Jigsaw story 002d2a50-10c3-4013-a35b-fc51e2805719 — pastoral farm gate. */
export const DEFAULT_PLAY_BACKGROUND = "farm_gate";

function catalogEntry(id) {
    const key = BG_IMAGE_CATALOG[id] ? id : DEFAULT_PLAY_BACKGROUND;
    return { id: key, url: BG_IMAGE_CATALOG[key] };
}

/** Journey play/hub uses the farm-gate scene. */
export function resolvePlayBackground() {
    return catalogEntry(DEFAULT_PLAY_BACKGROUND);
}

/** Daily play uses the same farm-gate scene. */
export function resolveDailyBackground() {
    return catalogEntry(DEFAULT_PLAY_BACKGROUND);
}

/**
 * Jigsaw story `eb10d67e-ba1f-4652-a54c-94c3890546a2` — dimmed fill behind journey play chrome.
 * Full illustration (not the 400px icon).
 */
export const JOURNEY_APP_BACKGROUND_URL =
    "https://puzzleinteract-images.s3.us-east-1.amazonaws.com/standalone/4eb1ffd2-3de2-412a-9a13-b027437a75a7/41e5ee49-e0b9-4139-8783-3242539eab97.png";
